export default __webpack_public_path__ + "static/media/honda.1e435b6b.svg";